var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagePreferencesStatusNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "244px",
    height: "118px",
    viewBox: "0 0 244 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "notFoundTitle"
  }, "Not found") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "notFoundTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.8162,2 C237.417449,2 241.958159,6.56669555 241.958159,12.2 C241.958159,17.8333044 237.417449,22.4 231.8162,22.4 L173.86215,22.4 C179.463399,22.4 184.004109,26.9666956 184.004109,32.6 C184.004109,38.2333044 179.463399,42.8 173.86215,42.8 L205.736878,42.8 C211.338127,42.8 215.878836,47.3666956 215.878836,53 C215.878836,58.6333044 211.338127,63.2 205.736878,63.2 L190.996391,63.2 C183.933946,63.2 178.208704,67.7666956 178.208704,73.4 C178.208704,77.1555363 181.106406,80.5555363 186.901811,83.6 C192.503061,83.6 197.04377,88.1666956 197.04377,93.8 C197.04377,99.4333044 192.503061,104 186.901811,104 L66.6471576,104 C61.0459084,104 56.5051988,99.4333044 56.5051988,93.8 C56.5051988,88.1666956 61.0459084,83.6 66.6471576,83.6 L10.1419588,83.6 C4.5407096,83.6 0,79.0333044 0,73.4 C0,67.7666956 4.5407096,63.2 10.1419588,63.2 L68.0960088,63.2 C73.697258,63.2 78.2379676,58.6333044 78.2379676,53 C78.2379676,47.3666956 73.697258,42.8 68.0960088,42.8 L31.8747275,42.8 C26.2734784,42.8 21.7327688,38.2333044 21.7327688,32.6 C21.7327688,26.9666956 26.2734784,22.4 31.8747275,22.4 L89.8287776,22.4 C84.2275284,22.4 79.6868188,17.8333044 79.6868188,12.2 C79.6868188,6.56669555 84.2275284,2 89.8287776,2 L231.8162,2 Z M233.790795,42.8 C239.429183,42.8 244,47.3666956 244,53 C244,58.6333044 239.429183,63.2 233.790795,63.2 C228.152407,63.2 223.58159,58.6333044 223.58159,53 C223.58159,47.3666956 228.152407,42.8 233.790795,42.8 Z",
    fill: "#ED2570",
    opacity: 0.100000001,
    transform: "translate(122.000000, 53.000000) scale(-1, 1) translate(-122.000000, -53.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 94.0790942,
    height: 73.2826628,
    rx: 0.990306254
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FD9BBF",
    strokeWidth: 3,
    strokeLinecap: "round",
    x: 0,
    y: 0,
    width: 94.0790942,
    height: 73.2826628,
    rx: 1.98061251
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#FD9BBF",
    strokeWidth: 3,
    strokeLinecap: "round",
    points: "1.83735183e-13 2.84923407 47.0395471 31.5681154 94.0790942 2.84923407"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.000000, 53.000000)",
    stroke: "#FD9BBF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 23.8905961,
    cy: 23.8905961,
    r: 22.3905961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.56215,
    y1: 42.1832606,
    x2: 55.654321,
    y2: 63.2006696,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePreferencesStatusNotFound);
export default __webpack_public_path__ + "static/media/manage-preferences-status-not-found.5a612ad976ec13430d47018d25b7e49b.svg";
export { ForwardRef as ReactComponent };